export const STUDIO_BRAND_LOGO = '/media/studio/brand/soft-ai-logo-transparent.png';
export const STUDIO_BRAND_COIN = '/media/studio/brand/coin-spark.png';
export const STUDIO_HERO_IMAGE =
	'/media/studio/haircolor/woman/haircolor-woman-platinum-blonde-hair.jpeg';
